import {
  DocumentOrganizationKeys,
  GoalFilterDocument,
  GroupByMode,
} from '@griply/types';

export const defaultProjectsOverviewFilterDocument: GoalFilterDocument = {
  [DocumentOrganizationKeys.SortingMode]: null,
  [DocumentOrganizationKeys.GroupByMode]: GroupByMode.Goal,
  // `null`, not `{}` — resetting must write a value that clears the stored
  // filters. `flattenSettings` drops empty objects, so `{}` would leave the
  // existing filters in place and the reset would do nothing.
  [DocumentOrganizationKeys.Filters]: null,
  [DocumentOrganizationKeys.CollapsedSections]: [],
};
